export enum CandidateStatus {
  Active = 'Active',
  InactiveHibernate = 'Inactive – Hibernate',
  InactiveHired = 'Inactive – Hired'
}
